export default {
  defaultLocale: "es",
};
